import { useMutation, useQueryClient } from '@tanstack/react-query';

import envVars from '../../../constants/envVars';
import useRequest from '../../../hooks/useRequest';
import { ORGANIZATION_MEMBER_KEY } from './constants';

type Payload = {
    hero_user_id: number;
};

const useMemberSetRtmMemberDisengaged = () => {
    const req = useRequest();
    const queryClient = useQueryClient();

    const request = (payload: Payload) => {
        return req({
            url: `${envVars.API_CLOUD_HOSTNAME}enterprise/set-rtm-disengaged`,
            method: 'POST',
            query: {
                hero_user_id: payload.hero_user_id
            }
        });
    };

    return useMutation({
        mutationFn: request,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [ORGANIZATION_MEMBER_KEY] });
        },
        onError: (error: { errors: string[] }) => {
            return error;
        }
    });
};

export default useMemberSetRtmMemberDisengaged;
